import type { Types as IdunSoftTypes } from '../types';
import type { OutTypes } from './schedules';

export default (groups: IdunSoftTypes.group[]): OutTypes.group[] => {
  return groups
    .reduce<OutTypes.group[]>((acc, group, index) => {
      const ids = group['ID'];
      if (!ids)
        throw new Error('A group does not have a unique key');

      if (acc.some(x => x.ids == ids))
        throw new Error(`A group ID "${ids}" exist multiple times at indices ${ index } and ${ acc.findIndex(x => x.ids == ids) }`);

      return acc.concat({
        ids:         ids,
        displayName: group['Klassnamn'],
        species:     'class',
      });
    }, []);
};